<template>
  <div class="container-fluid pt-4 px-4">
    <v-card flat rounded="lg" class="thread-list-card">
      <div class="data-table">
        <div class="table-responsive">
          <v-data-table
            :headers="grid.headers"
            :items="threads"
            :loading="loading"
            loading-text="Loading threads..."
            item-value="thread_id"
            class="custom-data-table"
          >
            <!-- Toolbar -->
            <template v-slot:top>
              <v-toolbar flat class="thread-list-toolbar">
                <v-toolbar-title>Threads</v-toolbar-title>
                <v-spacer />
                <router-link :to="{ path: '/tracker/thread' }">
                  <v-btn color="primary" variant="tonal" rounded="lg" class="mb-2">New Thread</v-btn>
                </router-link>
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5">
                      Are you sure you want to delete this thread?
                    </v-card-title>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn color="blue-darken-1" variant="text" @click="closeDelete">Cancel</v-btn>
                      <v-btn color="blue-darken-1" variant="text" @click="deleteItemConfirm">OK</v-btn>
                      <v-spacer />
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>

            <!-- Actions -->
            <template v-slot:[`item.actions`]="{ item }">
              <router-link :to="{ path: '/tracker/thread', query: { id: item.thread_id } }">
                <font-awesome-icon icon="edit" class="mr-2 cursor-pointer" />
              </router-link>
              <font-awesome-icon icon="trash" class="cursor-pointer" @click="deleteItem(item)" />
            </template>

            <!-- Date Formats -->
            <template v-slot:[`item.updated_at`]="{ item }">
              <span>{{ $helper.formatDate(item.updated_at, true) }}</span>
            </template>

            <template v-slot:[`item.created_at`]="{ item }">
              <span>{{ $helper.formatDate(item.created_at, true) }}</span>
            </template>
          </v-data-table>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { useAlertStore } from "@/stores";
import gql from "graphql-tag";

const THREAD_QUERY = gql`
  query Threads {
    threads {
      thread_id
      name
      type_id
      rule
      status
      created_at
      updated_at
    }
  }
`;

const DELETE_THREAD = gql`
  mutation DeleteThread($threadId: ID!) {
    deleteThread(thread_id: $threadId)
  }
`;

export default {
  name: "ThreadList",
  data: () => ({
    loading: false,
    dialogDelete: false,
    currentRow: {},
    threads: [],
    grid: {
      headers: [
        { title: "Thread ID", key: "thread_id" },
        { title: "Name", key: "name" },
        { title: "Type", key: "type_id" },
        { title: "Rule", key: "rule" },
        { title: "Status", key: "status" },
        { title: "Updated At", key: "updated_at" },
        { title: "Created At", key: "created_at" },
        { title: "Actions", key: "actions", sortable: false }
      ]
    }
  }),

  setup() {
    return {
      alertStore$: useAlertStore()
    };
  },

  methods: {
    deleteItem(item) {
      this.currentRow = item;
      this.dialogDelete = true;
    },
    async deleteItemConfirm() {
      await this.$apollo
        .mutate({
          mutation: DELETE_THREAD,
          variables: {
            threadId: this.currentRow.thread_id
          }
        })
        .then(() => {
          this.alertStore$.success("Thread deleted successfully.");
          this.$apollo.queries.threads.refetch();
        })
        .catch((error) => {
          this.alertStore$.error(error.message);
        });

      this.closeDelete();
    },
    closeDelete() {
      this.currentRow = {};
      this.dialogDelete = false;
    }
  },

  apollo: {
    threads: {
      query: THREAD_QUERY,
      loadingKey: "loading",
      error(error) {
        this.alertStore$.error(error.message);
      }
    }
  },

  watch: {
    dialogDelete(val) {
      if (!val) this.closeDelete();
    }
  }
};
</script>

<style scoped>
.thread-list-card {
  border: 1px solid var(--border);
}

.thread-list-toolbar {
  border-bottom: 1px solid var(--border);
}

.custom-data-table :deep(thead th) {
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-muted);
  background-color: #fafafa;
  border-bottom: 1px solid var(--border) !important;
}

.custom-data-table :deep(tbody tr) {
  transition: background-color 0.15s ease;
}

.custom-data-table :deep(tbody tr:hover) {
  background-color: #f8f9fb;
}

.custom-data-table :deep(tbody td) {
  font-size: 0.875rem;
  border-bottom: 1px solid #f1f2f4 !important;
}
</style>